function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "12",
  fill: "#313D53"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.903 23.817v-8.423H7v-3.248h2.903V9.548C9.903 6.624 11.774 5 14.42 5c.84 0 1.742.13 2.581.26v2.988h-1.484c-1.42 0-1.742.715-1.742 1.624v2.274h3.097l-.516 3.248h-2.58v8.476a12.098 12.098 0 01-3.872-.053z",
  fill: "#fff"
})));